export default "__VITE_ASSET__2_hF1N24__"